import DefaultCard from '../../../../components/default/DefaultCard';
import QuoteForm from '../forms/QuoteForm';
import ButtonSaveForm from '../../../../components/buttons/ButtonSaveForm';
import LazyLoading from '../../../../components/LazyLoading';
import DefaultCreatedModifiedUserForm from '../../../../components/default/DefaultCreatedModifiedUserForm';
import {
    QuoteDataForm,
    QuoteOfferTypeDataForm,
    QuoteShowDataForm
} from '../../../../app/models/Quote';
import { Society } from '../../../../app/models/Society';
import { Currency } from '../../../../app/models/Currency';
import { PaymentCondition } from '../../../../app/models/PaymentCondition';
import { Client } from '../../../../app/models/Client';
import QuoteShowForm from '../forms/QuoteShowForm';
import { Unit } from '../../../../app/models/Unit';
import { Auth } from '../../../../app/models/Auth';

interface Props {
    auth?: Auth | null;
    update?: () => void;
    quoteForm?: QuoteDataForm;
    quoteShowForm?: QuoteShowDataForm;
    setQuoteForm?: (quote: QuoteDataForm) => void;
    societies?: Society[];
    clients?: Client[];
    currencies?: Currency[];
    paymentConditions?: PaymentCondition[];
    offerTypes?: QuoteOfferTypeDataForm[];
    paymentMethods?: PaymentCondition[];
    units?: Unit[];
    errorFields?: Record<string, unknown>;
    fetchingQuote?: boolean;
    isFormShow?: boolean;
    disableUpdate?: boolean;
}

const QuoteTab = ({
    auth,
    fetchingQuote,
    update,
    quoteForm,
    quoteShowForm,
    setQuoteForm,
    societies,
    clients,
    paymentMethods,
    paymentConditions,
    offerTypes,
    currencies,
    units,
    errorFields,
    isFormShow = false,
    disableUpdate = false
}: Props) => {
    let generalDataContent: React.ReactNode = <LazyLoading />;

    if (!fetchingQuote) {
        if (
            !isFormShow &&
            quoteForm !== undefined &&
            typeof setQuoteForm === 'function' &&
            societies !== undefined &&
            clients !== undefined &&
            paymentConditions !== undefined &&
            paymentMethods !== undefined &&
            offerTypes !== undefined &&
            currencies !== undefined &&
            units !== undefined
        ) {
            generalDataContent = (
                <>
                    <QuoteForm
                        quoteForm={quoteForm}
                        setQuoteForm={setQuoteForm}
                        societies={societies}
                        clients={clients}
                        paymentConditions={paymentConditions}
                        paymentMethods={paymentMethods}
                        offerTypes={offerTypes}
                        currencies={currencies}
                        units={units}
                        errorFields={errorFields}
                        disableUpdate={disableUpdate}
                    />
                    <div className="row justify-content-end">
                        <div className="col-auto">
                            {auth?.roles && typeof update === 'function' && (
                                <ButtonSaveForm callbackSave={update} />
                            )}
                        </div>
                    </div>
                </>
            );
        } else if (isFormShow && quoteShowForm !== undefined) {
            generalDataContent = <QuoteShowForm quoteForm={quoteShowForm} />;
        }
    }

    const createdBy = !isFormShow ? quoteForm?.created_user : quoteShowForm?.created_user;
    const createdAt = !isFormShow ? quoteForm?.created_at : quoteShowForm?.created_at;
    const updatedBy = !isFormShow ? quoteForm?.last_modified_user : quoteShowForm?.last_modified_user;
    const updatedAt = !isFormShow ? quoteForm?.updated_at : quoteShowForm?.updated_at;
    const status = !isFormShow ? quoteForm?.status : quoteShowForm?.status;

    return (
        <>
            <div className="row">
                <div className="col-md-6">
                    <DefaultCard>
                        <div className="h3 mt-0 mb-2 card-title">Datos Generales</div>
                        {generalDataContent}
                    </DefaultCard>
                </div>
                <div className="col-md-6">
                    <div className="card">
                        <div className="card-body">
                            <div className="h3 mt-0 mb-2 card-title">Usuarios</div>
                            {!fetchingQuote ? (
                                <DefaultCreatedModifiedUserForm
                                    createdBy={createdBy}
                                    createdAt={createdAt}
                                    updatedBy={updatedBy}
                                    updatedAt={updatedAt}
                                    status={status}
                                />
                            ) : (
                                <LazyLoading />
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default QuoteTab;
